<template>
  <v-dialog
    class="elevation-0 theme-border"
    v-model="flag"
    width="800"
    scrollable
    :class="isExtension ? 'ext-margin' : 'non-ext-margin'"
  >
    <v-card>
      <!-- Title bar -->
      <v-card-title
        class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
      >
        <div class="d-flex justify-center align-center" style="width: 90%">
          Advanced Filters
        </div>

        <v-spacer></v-spacer>
        <v-icon small color="#757096" @click="flag = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="py-4 custom-dialog">
        <!-- Dashboard view -->
        <v-row
          v-if="
            getSelectedCompany.role == 'admin' ||
            getSelectedCompany.role == 'owner'
          "
          no-gutters
        >
          <v-col md="6" cols="12">
            <div
              class="text-capitalize font-weight-bold body-2 dark-purple-text"
            >
              View By
            </div>
            <!-- Company -->
            <v-chip
              @click="
                $store.commit('setDashboardView', 'company');
                $store.commit('setDashboardMember', null);
              "
              small
              class="mt-2 pointer mr-2"
              :class="
                getDashboardView == 'company'
                  ? 'blue-chip-color'
                  : 'grey-chip-color'
              "
            >
              Company
            </v-chip>
            <!-- Department -->
            <v-chip
              v-if="getAllMembers && getAllMembers.length"
              @click="$store.commit('setDashboardView', 'departments')"
              small
              class="mt-2 pointer mr-2"
              :class="
                getDashboardView == 'departments'
                  ? 'blue-chip-color'
                  : 'grey-chip-color'
              "
            >
              Department
            </v-chip>
            <!-- Team Lead -->
            <v-chip
              v-if="getTeamLeads && getTeamLeads.length"
              @click="$store.commit('setDashboardView', 'team leads')"
              small
              class="mt-2 pointer mr-2"
              :class="
                getDashboardView == 'team leads'
                  ? 'blue-chip-color'
                  : 'grey-chip-color'
              "
            >
              Team Lead
            </v-chip>
            <!-- Employee -->
            <v-chip
              v-if="getAllMembers && getAllMembers.length"
              @click="$store.commit('setDashboardView', 'employees')"
              small
              class="mt-2 pointer mr-2"
              :class="
                getDashboardView == 'employees'
                  ? 'blue-chip-color'
                  : 'grey-chip-color'
              "
            >
              Employee
            </v-chip>
          </v-col>
          <!-- Department Dropdown -->
          <v-col
            md="6"
            cols="12"
            v-if="
              (getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'owner') &&
              getDashboardView == 'departments'
            "
          >
            <div
              @click="openDepartmentDialog = true"
              id="dept-dropdown"
              class="theme-border dusty-purple-text mt-3 text-capitalize d-flex align-end border-radius-2 px-2 py-2 pointer"
            >
              {{
                getDashboardDepartment
                  ? getDashboardDepartment.name
                  : "Department Name"
              }}
              <v-spacer></v-spacer>
              <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
            </div>
          </v-col>
          <!-- Member Dropdown -->
          <v-col
            md="6"
            cols="12"
            v-if="
              (getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'owner') &&
              (getDashboardView == 'employees' ||
                getDashboardView == 'team leads')
            "
          >
            <div
              id="dashboard-member-dropdown"
              @click="openMemberDialog = true"
              class="theme-border dusty-purple-text mt-3 text-capitalize d-flex align-end border-radius-2 px-2 py-2 pointer"
            >
              <div
                v-if="
                  getSelectedCompany.role == 'admin' ||
                  getSelectedCompany.role == 'owner'
                "
                class="pointer body-2 dark-purple-text font-weight-bold d-flex align-center text-capitalize"
              >
                {{
                  getDashboardMember
                    ? getDashboardMember.name
                      ? getDashboardMember.name
                      : getDashboardMember.email
                    : ""
                }}
              </div>
              <v-spacer></v-spacer>
              <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
            </div>
          </v-col>
        </v-row>
        <div
          v-if="
            getSelectedCompany.role == 'admin' ||
            getSelectedCompany.role == 'owner'
          "
          class="border-bottom my-4"
        ></div>
        <!-- Date Range Filter -->
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <div class="dark-purple-text font-weight-bold body-2">By Time</div>
            <div :class="isMac ? 'edited_scrollbar' : ''">
              <v-list>
                <div
                  v-for="list of dropdownList"
                  :key="list.text"
                  class="status-list-min-height caption anchor-hover d-flex pointer"
                  @click="$store.commit('setDashboardDateFilter', list.text)"
                >
                  <v-icon small color="#1cc283" class="pr-2">
                    {{
                      getDashboardDateFilter == list.text
                        ? "mdi-checkbox-marked-circle"
                        : "mdi-checkbox-blank-circle-outline"
                    }}</v-icon
                  >
                  <v-list-item-content
                    :class="
                      getDashboardDateFilter == list.text
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                    class="px-3"
                    >{{ list.text }}</v-list-item-content
                  >
                </div>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="border-top py-3">
        <div class="d-flex align-center">
          <v-btn
            @click="resetFilters"
            color="#edebf9"
            depressed
            small
            class="text-capitalize"
          >
            <v-icon color="#2a206a" small>mdi-restore</v-icon>
            <span class="body-2 mx-1 dark-purple-text">Reset Filters</span>
          </v-btn>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
      <!-- DROPDOWNS -->
      <!-- Department Dropdown -->
      <v-menu
        :close-on-content-click="false"
        activator="#dept-dropdown"
        offset-y
        content-class="white"
        v-model="openDepartmentDialog"
      >
        <div class="py-0" :class="isMac ? 'edited_scrollbar' : ''">
          <div class="theme-border mx-1 my-1 rounded">
            <v-text-field
              autocomplete="off"
              class="body-2"
              color="#757096"
              prepend-inner-icon="mdi-magnify"
              background-color="white"
              placeholder="Search by name"
              hide-details
              dense
              flat
              solo
              autofocus
              v-model="searchDepartment"
            >
            </v-text-field>
          </div>
          <v-list
            max-height="180"
            class="overflow-scroll pointer pa-0"
            scrollable
          >
            <div
              v-for="(item, index) in filteredDepartments"
              :key="index"
              class="listing-hover caption pa-3"
              :class="
                getDashboardDepartment
                  ? getDashboardDepartment.id == item.id
                    ? 'bg-selected'
                    : ''
                  : ''
              "
              @click="selectDepartment(item)"
            >
              <div class="d-flex">
                <profileImage
                  v-show="item.image ? ':src' : ':username'"
                  inline
                  :username="item.name"
                  :size="22"
                  :userProfile="true"
                  :circular="true"
                  class="ml-2 text-light"
                ></profileImage>
                <div
                  class="mx-2 d-inline-block text-truncate"
                  style="max-width: 120px"
                  :class="[item.name ? 'text-capitalize' : '']"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div v-if="searchDepartment && !filteredDepartments.length">
              <p class="no-results-found my-1">No results found</p>
            </div>
          </v-list>
        </div>
      </v-menu>
      <!-- Member Dropdown -->
      <v-menu
        :close-on-content-click="false"
        activator="#dashboard-member-dropdown"
        offset-y
        content-class="white"
        v-model="openMemberDialog"
      >
        <div
          v-if="
            getDashboardView == 'employees' || getDashboardView == 'team leads'
          "
          class="py-0"
          :class="isMac ? 'edited_scrollbar' : ''"
        >
          <div class="theme-border mx-1 my-1 rounded">
            <v-text-field
              autocomplete="off"
              class="body-2"
              color="#757096"
              prepend-inner-icon="mdi-magnify"
              background-color="white"
              placeholder="Search by name"
              hide-details
              dense
              flat
              solo
              autofocus
              v-model="search"
            >
            </v-text-field>
          </div>
          <v-list
            max-height="180"
            class="overflow-scroll pointer pa-0"
            scrollable
          >
            <div
              v-for="(item, index) in list"
              :key="index"
              class="listing-hover caption pa-3"
              :class="
                getDashboardMember && getDashboardMember.name == item.name
                  ? 'bg-selected'
                  : ''
              "
              @click="selectMember(item)"
            >
              <div class="d-flex">
                <profileImage
                  v-show="item.image ? ':src' : ':username'"
                  :src="item.image"
                  inline
                  :username="item.name ? item.name : item.email"
                  :size="22"
                  :userProfile="true"
                  :circular="true"
                  class="ml-2 text-light"
                ></profileImage>
                <div
                  class="mx-2 d-inline-block text-truncate"
                  style="max-width: 120px"
                  :class="[item.name ? 'text-capitalize' : '']"
                >
                  {{ item.name ? item.name : item.email }}
                </div>
              </div>
            </div>
            <div v-if="search && !list.length">
              <p class="no-results-found my-1">No results found</p>
            </div>
          </v-list>
        </div>
      </v-menu>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import dateFilter from "@/dateFilter.js";
export default {
  props: ["drawer"],
  components: {
    profileImage: () => import("@/components/Includes/ProfileImage"),
  },
  data() {
    return {
      searchDepartment: null,
      search: null,
      flag: false,
      dropdownList: [
        { text: "Today" },
        { text: "Yesterday" },
        { text: "Last 7 days" },
        { text: "Last 30 days" },
        { text: "This month" },
      ],
      openDepartmentDialog: false,
      openMemberDialog: false,
    };
  },
  watch: {
    drawer(value) {
      if (value) this.flag = true;
    },
    flag(value) {
      if (!value) this.$emit("update:drawer", false);
    },
    getDashboardView(value) {
      if (value) {
        if (value == "employees") {
          this.$store.commit("setDashboardFilter", {
            toggle: "employee",
            employee_id:
              this.getSelectedCompany.role == "employee"
                ? this.getLoggedInUser.id
                : this.getAllMembers[0]
                ? this.getAllMembers[0].id
                : null,
            leader_id: null,
          });
          this.$store.commit(
            "setDashboardMember",
            this.getSelectedCompany.role == "employee"
              ? this.getLoggedInUser
              : this.getAllMembers
              ? this.getAllMembers[0]
              : {}
          );
        }
        if (value == "team leads") {
          this.$store.commit("setDashboardFilter", {
            toggle: "names",
            leader_id:
              this.getSelectedCompany.role == "team-manager"
                ? this.getLoggedInUser.id
                : this.getTeamLeads[0]
                ? this.getTeamLeads[0].id
                : null,
            employee_id: null,
          });
          this.$store.commit(
            "setDashboardMember",
            this.getSelectedCompany.role == "team-manager"
              ? this.getLoggedInUser
              : this.getTeamLeads
              ? this.getTeamLeads[0]
              : {}
          );
        }
        if (value == "company") {
          this.$store.commit("setDashboardFilter", {
            employee_id: null,
            leader_id: null,
            toggle: "company",
          });
        }
        if (value == "departments") {
          this.$store.commit("setDashboardFilter", {
            employee_id: null,
            leader_id: null,
            toggle: "departments",
          });
        }
      }
    },
    getDashboardDateFilter(value) {
      dateFilter.update(value, "setDashboardFilter");
    },
  },
  computed: {
    ...mapGetters([
      "getLoggedInUser",
      "getSelectedCompany",
      "getView",
      "getDashboardDateFilter",
      "getTeamLeads",
      "getAllMembers",
      "getDashboardFilters",
      "getDashboardView",
      "getDashboardMember",
      "getDepartments",
      "getDashboardDepartment",
    ]),
    // List of employees/team leads
    list() {
      return this.getDashboardView == "team leads"
        ? this.search
          ? this.getTeamLeads.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : item.email.toLowerCase().includes(this.search.toLowerCase());
            })
          : this.getTeamLeads
        : this.getDashboardView == "employees"
        ? this.search
          ? this.getAllMembers.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : item.email.toLowerCase().includes(this.search.toLowerCase());
            })
          : this.getAllMembers
        : [];
    },
    filteredDepartments() {
      return this.searchDepartment && this.getDepartments
        ? this.getDepartments.filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.searchDepartment.toLowerCase())
              : false;
          })
        : this.getDepartments;
    },
  },
  methods: {
    resetFilters() {
      if (
        this.getSelectedCompany.role == "admin" ||
        this.getSelectedCompany.role == "owner"
      ) {
        this.$store.commit("setDashboardView", "company");
        this.$store.commit("setDashboardMember", null);
      }
      this.$store.commit("setDashboardDateFilter", "Today");
    },
    selectMember(member) {
      if (member) {
        this.$store.commit("setDashboardMember", member);
        if (this.getDashboardView == "team leads") {
          this.$store.commit("setDashboardFilter", {
            leader_id: member.id,
          });
        }
        if (this.getDashboardView == "employees") {
          this.$store.commit("setDashboardFilter", {
            employee_id: member.id,
          });
        }
      }
    },
    selectDepartment(department) {
      if (department) this.$store.commit("setDashboardDepartment", department);
      this.$store.dispatch("fetchDepartmentMembers", department);
    },
  },
  mounted() {
    this.$store.commit("setDashboardDepartment", "");
    dateFilter.update(this.getDashboardDateFilter, "setDashboardFilter");
    this.$store.commit(
      "setDashboardView",
      this.getSelectedCompany.role == "employee"
        ? "employees"
        : this.getSelectedCompany.role == "team-manager"
        ? "team leads"
        : "company"
    );
  },
};
</script>

<style scoped>
.ext-margin {
  margin-top: 48px !important;
}
.non-ext-margin {
  margin-top: 46px !important;
}
</style>
